import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import ReviewSectionHeader from '../ReviewSectionHeader';

const Wrapper = styled.div`
  display: grid;
  grid-auto-flow: row;
  grid-gap: 15px;
  padding: 15px 0;
  ${(props) => props.styles};
`;

const ItemsWrapper = styled.div`
  display: grid;
  grid-template-columns: ${(props) => (props.stacked ? '1fr' : 'auto 1fr')};
  grid-gap: ${(props) => (props.stacked ? '8px' : '15px')};
`;

const Label = styled.span`
  max-width: ${(props) => (props.stacked ? '100%' : '200px')};
  font-weight: bold;
`;

const LineItem = ({ item, stacked }) => (
  <React.Fragment key={item.key}>
    <Label data-testid="additional-details-item-label" stacked={stacked}>
      {item.label}
    </Label>
    <span data-testid="additional-details-item-content">{item.value}</span>
  </React.Fragment>
);

const Header = ({ title, styles }) => {
  if (!title) return null;
  if (typeof title === 'string')
    return <ReviewSectionHeader styles={styles}>{title}</ReviewSectionHeader>;
  return title;
};

const AdditionalDetails = ({ title, items, stacked, headerStyle, wrapperStyle }) => {
  if (items.length === 0) return null;
  return (
    <Wrapper styles={wrapperStyle}>
      <Header styles={headerStyle} title={title} />
      <ItemsWrapper data-testid="additional-details-wrapper" stacked={stacked}>
        {items.map((item) => (
          <LineItem stacked={stacked} key={item.key} {...{ item }} />
        ))}
      </ItemsWrapper>
    </Wrapper>
  );
};

LineItem.defaultProps = {
  stacked: false,
};

LineItem.propTypes = {
  item: PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.string,
  }).isRequired,
  stacked: PropTypes.bool,
};

AdditionalDetails.defaultProps = {
  title: null,
  items: [],
  stacked: false,
  headerStyle: '',
  wrapperStyle: '',
};

AdditionalDetails.propTypes = {
  stacked: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
  headerStyle: PropTypes.string,
  wrapperStyle: PropTypes.string,
};

export default AdditionalDetails;
